/**
 * Camera enum
 */
export enum CamsEnum {
    FIRST_CAM = 'first-cam',
    SECOND_CAM = 'second-cam'
}
/**
 * Manage session component users/caller
 */
export enum ManageSessionCallerEnum {
    DASHBOARD,
    GUEST,
    SESSION
}
/**
 * User types
 */
export enum UserTypeEnum {
    GUEST = "GUEST",
    USER = "USER",
    HOST = "HOST"
}

/**
 * Media devices
 */
export enum MediaDevicesEnum {
    NONE,
    AudioInput,
    VideoOutput,
}

/**
 * Custome date time format
 */
export enum DateTimeFormatEnum {
    MONTH_DAY = 'monthDay',
    MONTH_NAME = 'monthName',
    TIME_12 = 'time12',
    DD_MM_C_YY_H_HH12 = 'ddmm,yy-hh12',
    BILLING_DATE = "billingDate",
    IS_TODAY = "istoday"
}

/**
 * local recording status
 */
export enum LocaRecStateEnum {
    ON,
    OFF
}
/**
 * status of blob chunks
 */
export enum RecBlobStateEnum {
    PENDING,
    FAILED,
    PROCESS,
    UPLOADED
}
/**
 * Admin action on guest side
 */
export enum ConferenceCommandEnum {
    endCall = 0,
    stopLocalRec = 1,
    startLocalRec = 2,
    pauseLocalRec = 3,
    resumeLocalRec = 4,
    updateTimmer = 5,
    mute = 6,
    stopVideo = 7,
    mapControl = 8,
    customizeSetting = 9,
    layout = 10,
    mixerCustomize = 11,
    guestLowMemory = 12,
    chat = 13,
    raiseHand = 14,
    admit = 15,
    lowProcessor = 16,
    displayMessageOnConference = 17,
    additionalInfoReq = 18,
    additionalInfoRes = 19,
    introMedia = 20,
    mixerAdded = 21,
    participantWaitingState = 22,
    hostParticipantWaitingState = 23,
    timeSyncErr = 24,
    echoCancellation = 25,
    joinedParticipantIds = 26,
    recordingError = 27,
    localRecording = 28,
    participantWarning = 29,
    audienceLimit = 30,
    askToReSendMixerEvent = 31,
    videoResolution = 32,
    recordingResolution = 33,
    dragParticipant = 35,
    participantsPosition = 39,
    uploadingStatus = 40,
    requestUploadingStatus = 41,
    echoChange = 42,
    askUnmute = 43,
    echoStatus = 44
}

export enum AppStatusEnum {
    Success = 'success',
    Failed = 'failed'
}

export enum SocialNetworkEnum {
    Facebook = 'facebook',
    Youtube = 'youtube',
    Both = 'both',
    Linkedin = 'linkedin',
    All = 'all'
}

export enum RecordingStateEnum {
    none,
    Start,
    Stop
}

export enum SnackClassEnum {
    Default = 'default',
    Error = 'snack-error',
    Success = 'snack-success',
    Warning = 'snack-warning'
}

export enum SocialNetworkTypeEnum {
    Session,
    Setting
}

export enum RecordingTypeEnum {
    none,
    audioOnly,
    audioVideo
}

export enum RecordingQualityEnumDe {
    none,
    p480,
    p720,
    p1080,
    p4k,
    p1440
}


export enum CusomizeRoomEventEnum {
    tagText = 'tagText',
    isTag = 'isTag',
    tagBgColor = 'tagBgColor',
    tagTextColor = 'tagTextColor',
    tagPos = 'tagPos',
    layoutBgColor = 'layoutBgColor',
    logoPos = 'logoPos',
    isLogo = 'logoToggle',
    isLayout = 'layoutBgtoggle',
    deleteLogo = 'deleteLogo',
    applyLogoGuest = 'applyLogoGuest',
    resizeImage = 'resizeImage',
    layout = "layout",
    ComponentLoaded = "loaded",
    logoPreview = 'preview',
    secondLogoPos = 'secondLogoPos',
    isSecondLogo = 'isSecondLogo',
    bannerShape = 'bannerShape',
    secondLogoPreview = 'secondLogoPreview',
    resizeSecondImage = 'resizeSecondImage',
    media = 'media',
    volumeChange = 'volumeChange',
    introSetting = 'introSetting',
    refreshMedia = 'refreshMedia'
}

export enum ConferenceEventsEnum {
    streamAdded = 'streamAdded',
    streamRemoved = 'streamRemoved',
    invitation = 'invitation',
    participantAdded = 'participantAdded',
    participantUpdated = 'participantUpdated',
    received = 'received',
    ended = 'ended',
    joined = 'joined',
    switched = 'switched',
    qualityIndicators = 'qualityIndicators',
    streamUpdated = 'streamUpdated',
    autoplayBlocked = 'autoplayBlocked'
}


export enum BrowserEnum {
    chrome = 'chrome',
    firefox = 'firefox',
    safari = 'safari',
    edge = 'edge',
    edgeChromium = 'edge-chromium'
}

export enum OsEnum {
    macOS = 'Mac OS',
    iOS = 'iOS',
    androidOS = 'Android OS',
    windows = 'Windows'
}

export enum BrowserVersionSupportedEnum {
    chrome = 81,
    firefox = 76,
    edgeChromium = 85
}

export enum FacebookDestinationEnum {
    page = 'page',
    group = 'group',
    timeline = 'timeline'
}

export enum EnvironmentEnum {
    dev,
    stage,
    production
}

export enum SessionFilter {
    all,
    upcomming,
    lastWeek,
    lastMonth,
    lastYear,
    customRange,
    past,
    today
}


/**
 * none nothing
 * used when session is used
 * recorded when session is recorded
 * when session is streamed on facebook
 * when session is streamed on youtube
 * when session is streamed on all (or all above state is completed)
 */
export enum SessionStateEnum {
    none,
    used,
    recorded,
    streamed,
    all,
    ended = 6
}



export enum ConferenceLayoutsEnum {
    ProducerView,
    NormalView
}


export enum ConferenceViewTypeEnum {
    init,
    layout,
    participant
}
/**
 * recording states
 */
export enum RecordingStateEnum {
    process = 'process'
}

/**
 * notification type enum 
 */
export enum NotificationTypeEnum {
    storageFull,
    planExpiry,
    planCancellation
}

export enum RecordingFileStateEnum {
    none,
    Stopped,
    Started,
    EndedData,
    Uploaded,
    Recording
}

export enum ChatTypeEnum {
    private,
    public
}


/**
 * type of linkedin destinations
 */
export enum DestinationEnum {
    none,
    page,
    timeline,
    group,
    event,
    channel,
    linkedinProfile,
    linkedinOrganization
}


export enum ChatEventTypeEnum {
    load,
    liveChatLoad
}

export enum enumeratDevicesTypeEnum {
    videoinput = 'videoinput',
    audioinput = 'audioinput',
    audiooutput = 'audiooutput'
}

/**
 * type of logo for upload component
 */
export enum LogoTypeEnum {
    primary,
    secondary
}

/**
 * user media type enum
 */
export enum MediaTypeEnum {
    intro,
    media
}

export enum ContentTypeEnum {
    none,
    mp4,
    mp3
}

/**
 * Particiapnt roles
 */
export enum SessionUserRole {
    guest,
    audience,
    producer,
    host
}

/**
 * DeviceSetting applier enum
 */
export enum DeviceSettingApplierEnum {
    None = '',
    Setting = 'setting',
    Camera = 'cam',
    Mic = 'mic'
}

/**
 * session error enum
 */
export enum SessionErrorEnum {
    PutFileIdb,
    RemoveFileIdb,
    LocalRecording,
    GetFileIDB,
    StartLiveSession,
    SessionNotLive,
    MetaRecordingNotAdded,
    LiveRecNotStarted,
    LocalRecordingEventNotSend,
    MixerAddedEvent,
    MixerNotAdded,
    EndCall,
    PutChunkToDb,
    Constraints,
    Camera,
    Mic,
    LIVE_STREAM
}

/**
 * mixer layout
 */
export enum MixerLayout {
    Record = 'record',
    Stream = 'stream'
}

/**
 * session action permisson according to role
 */
export enum SessionRolePermissonType {
    isProducer,
    isAudience,
    isHost,
    isGuest,
    isProducerOrAudienceRole,
    manageSessionPlayAudio,
    manageSessionEchoDisable,
    audienceViewBtn,
    endCallBtn,
    copyInvite,
    micBtn,
    camBtn,
    customizeBtn,
    chatBtn,
    settingBtn,
    raiseHandBtn,
    host,
    producer,
    devicePermission,
    localRecord,
    conferenceListener,
    audience,
    participantWarning,
    uploadingStatus
}

/**
 * warning enum 
 */
export enum WarningEnum {
    lowStorage,
    lowProcessor
}

/**
 * participant count based on differenent role or states 
 */
export enum ParticipantCountTypeEnum {
    audience = 'audience',
    waiting = 'waiting',
    nonWaiting = 'non-waiting',
    audienceLimit = 'audienceLimit'
}
